import currencyFormatter from 'currency-formatter'
export default {
  name: 'regExp',
  htmlCommentSingle: /<!--(.*?)-->/gm,
  naturalNumber: /^[1-9]\d*$/,
  expEmail: /^([\w-]+(?:\.[\w-]+)*)@((?:[\w-]+\.)*\w[\w-]{0,66})\.([a-z]{2,6}(?:\.[a-z]{2})?)$/,
  expPhone: /^\d{2,3}-\d{3,4}-\d{4}$/,
  webfont: /(woff|woff2)$/,
  image: /(png|jpeg|svg|jpg|gif)$/,
  numberOnly: function (num) {
    return num.toString().replace(/[^0-9.]/g, '')
  },
  priceOnly: function (num) {
    return num.toString().replace(/[^0-9.]/g, '')
  },
  comma: function (num) {
    const reg = /^([-+]?\d+)(\d{3})(\.\d+)?/
    let string = '' + (num != null ? num : '')
    string = string.replace(/[^-+.\d]/g, '')
    while (reg.test(string)) string = string.replace(reg, '$1' + ',' + '$2' + '$3')
    return string
  },
  uncomma: function (str) {
    str = `${str}`
    return str.replace(/[^-.\d]/g, '')
  },
  isEmptyString: function (str) {
    let result = str.trim().length === 0
    return result
  },
  replaceAllEmpty: function (str) {
    str = `${str}`
    return str.replace(/(\s*)/g, '').toLowerCase()
  },
  camelize: function (str) {
    return str ? str.replace(/([-_][a-z])/g,
      (group) => group.toUpperCase()
        .replace('-', '')
        .replace('_', '')
    ) : ''
  },
  camelToSnake: function (str) {
    return str.replace(/[A-Z]/g, (letter, index) => { return index === 0 ? letter.toLowerCase() : '_' + letter.toLowerCase()})
  },
  priceFormat: function (price, code, disabledSymbol) {
    const format = currencyFormatter.format(price, { code: (code || '').toUpperCase(), ...disabledSymbol && {symbol: ''} })
    const formatArr = format.split('')
    const regex = new RegExp(/[0-9]/)
    const firstNumber = formatArr.findIndex((e) => regex.test(e))
    formatArr[firstNumber] = disabledSymbol ? formatArr[firstNumber] : ' ' + formatArr[firstNumber]
    return formatArr.join('')
  },
  naturalNumberOnly(str) {
    // 숫자인 경우 문자열로 변환
    if (typeof str === 'number') str = `${str}`
    if (typeof str !== 'string') return ''
  
    // 숫자만 추출
    let numbers = str.replace(/\D/g, '')
  
    // 숫자가 없거나 '0'만 포함된 경우 빈 문자열 반환
    return numbers.replace(/^0+/, '') || ''
  },
  priceInput: function (num) {
    num = num.toString().replace(/[^0-9.]/g, '')
  
    // 여러 개의 소수점이 있으면 첫 번째만 유지
    const parts = num.split('.')
    if (parts.length > 2) {
      num = parts[0] + '.' + parts.slice(1).join('').replace(/\./g, '')
    }
  
    // 정수 부분의 앞쪽 0 제거 (예: "0123" → "123")
    let [integerPart, decimalPart] = num.split('.')
  
    integerPart = integerPart.replace(/^0+/, '') || '' // 0만 남는 경우 방지
  
    // 최종 결과
    return decimalPart !== undefined ? `${integerPart}.${decimalPart}` : integerPart
  }
  
}
